import { getCalendarSurfaceStore } from 'mini-calendar-surface-store';
import { setTodayDate } from '../mutators/dateMutators';
import { today, getTimestamp } from 'owa-datetime';

/**
 * Check if the date has changed and update the calendar state accordingly.
 */
export default function onDayChange(ctx?: any) {
    const todayDate = today();
    const currentDateInStore = getCalendarSurfaceStore().todayDate;
    if (getTimestamp(currentDateInStore) !== getTimestamp(todayDate)) {
        ctx &&
            ctx.signal('DayChanged', {
                oldDate: currentDateInStore.toString(),
                newDate: todayDate.toString(),
            });
        setTodayDate(todayDate);
    }
}
